import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'PromptTermsDialog.error',
    defaultMessage: 'You must accept terms and conditions',
  },
});
